export default __webpack_public_path__ + "static/media/ic_fantom_16.cfc3df6c.svg";